import { ReactElement, useEffect, useMemo, useState } from 'react'
import { Tabs } from '../..'
import { TabsGroupProps } from './props'
import { StyledTabsGroup } from './styles'

const TabsGroup = ({
    activeTab,
    onChange = () => undefined,
    tabs,
    variant,
    ...props
}: TabsGroupProps): ReactElement => {
    const activeValue = useMemo(
        () =>
            tabs.find((tab) => tab.value === activeTab)?.value ??
            (tabs.length !== 0 ? tabs[0].value : undefined),
        [activeTab, tabs]
    )
    const [currentTab, setCurrentTab] = useState(activeValue)

    useEffect(() => setCurrentTab(activeValue), [activeValue])

    const tabsList = useMemo(
        () => tabs.map(({ content, ...rest }) => rest),
        [tabs]
    )

    const tabsContent = useMemo(
        () => tabs.find((tab) => tab.value === currentTab)?.content,
        [currentTab, tabs]
    )

    return (
        <StyledTabsGroup {...props}>
            <Tabs
                activeTab={activeTab}
                onChange={(val) => {
                    onChange(val)
                    setCurrentTab(val)
                }}
                tabs={tabsList}
                variant={variant}
            />
            {tabsContent}
        </StyledTabsGroup>
    )
}

export default TabsGroup

export { StyledTabsGroup }
